export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14142.e1d026c1.jpg";